import { io, Socket } from "socket.io-client";

let socket: Socket | null = null;

export const createSocket = (accessToken: string): Socket | null => {
  if (!accessToken) return null;

  // Disconnect existing socket if any
  if (socket) {
    socket.removeAllListeners();
    socket.disconnect();
  }

  socket = io(import.meta.env.VITE_SOCKET_URL, {
    auth: {
      token: accessToken,
    },
    autoConnect: false,
    reconnection: true,
    reconnectionDelay: 1000,
    reconnectionDelayMax: 5000,
    // Keep realtime recovery independent from HTTP request lifecycle. Socket.IO
    // already applies randomized exponential backoff, so it is safe to keep
    // trying while the portal remains open.
    reconnectionAttempts: Infinity,
  });

  // Setup basic error logging
  socket.on("connect", () => console.log("Socket connected:", socket?.id));
  socket.on("disconnect", (reason) =>
    console.log("Socket disconnected:", reason)
  );
  socket.on("connect_error", (error) =>
    console.error("Socket connection error:", error.message)
  );

  return socket;
};

export const getSocket = (): Socket => {
  if (!socket) throw new Error("Socket not initialized");
  return socket;
};

export const disconnectSocket = (): void => {
  if (socket) {
    socket.removeAllListeners();
    socket.disconnect();
    socket = null;
  }
};
